angular.module('admin.directives')

.directive('sponsoredAgentList', ['AgentService', function(AgentService){
  return {
    restrict: 'EA',
    controllerAs: 'sponsoredAgentListCtrl',
    bindToController: {
      agent: '=',
    },
    scope: {},
    templateUrl: '/admin/templates/partials/sponsored-agent-list.html',

    controller: function(){
      let ctrl = this;
      ctrl.reas = [];


      function refreshData(){
        ctrl.loading = true;

        AgentService.getSponsoredAgents(ctrl.agent.id)
          .then((data) => {
            ctrl.loading = false;
            ctrl.error = null;
            ctrl.reas = data;
          })
          .catch((errorMessage) => {
            ctrl.error = errorMessage;
          });
      }

      refreshData();
    }
  }
}]);
